module.exports = kolibriGlobal.utils.validators;